/* Baddies & Budgets - Header Nav Fix
 * Fixes desktop nav blinking caused by Symmetry theme's inlineNavigationCheck
 * This script runs after the header section and overrides the theme's nav check
 */
(function() {
  'use strict';

  function applyNavFix() {
    // 1. Clear the opacity=0 inline style immediately
    var mainNav = document.getElementById('main-nav');
    if (mainNav) mainNav.style.opacity = '';

    // 2. Force inline-permitted class on pageheader
    var ph = document.getElementById('pageheader');
    if (ph) ph.classList.add('pageheader--layout-inline-permitted');

    // 3. Override theme.inlineNavigationCheck to always keep the class
    if (window.theme && typeof theme.inlineNavigationCheck === 'function') {
      var origFn = theme.inlineNavigationCheck;
      theme.inlineNavigationCheck = function() {
        origFn.call(this);
        var ph2 = document.getElementById('pageheader');
        if (ph2) ph2.classList.add('pageheader--layout-inline-permitted');
        var nav = document.getElementById('main-nav');
        if (nav) nav.style.opacity = '';
      };
    }
  }

  // Run immediately (synchronously - before any setTimeout fires)
  applyNavFix();

  // Also run after DOM is ready in case elements weren't available
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyNavFix);
  }

  // Run after window load as final safety net
  window.addEventListener('load', applyNavFix);
})();
